import * as yup from "yup";

export const SmsNotificationvalidationSchema = yup.object().shape({
  beaconMAC: yup
    .string()
    .required("1:Beacon MAC is required")
    .length(12, "2:Beacon MAC must be exactly 12 characters")
    .matches(
      /^[A-Z0-9]+$/,
      "3:Beacon MAC must contain only uppercase letters and numbers"
    )
    .matches(
      /^(?=.*[A-Z])(?=.*[0-9])[A-Z0-9]+$/,
      "4:Beacon MAC must contain at least one letter and one number"
    ),

  phoneNumber: yup
    .string()
    .required("5:Phone number is required")
    .matches(/^\+?[0-9]+$/, "6:Phone number must contain only digits")
    .min(10, "7:Phone number must be at least 10 digits")
    .max(15, "8:Phone number must not exceed 15 digits"),
});
